import Select from './select2'
import Toggle from './toggle'
import DateRangePicker from './daterangepicker'
import Radio from './radio'

export default function registerVueDirectives(Vue) {
	Vue.directive('select', Select);
	Vue.directive('toggle', Toggle);
	Vue.directive('datepicker', DateRangePicker);
	Vue.directive('radio', Radio);
}



// WEBPACK FOOTER //
// ./src/directives/index.js